// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-module__Vof5f {\n    top: 0;\n    position: fixed;\n    width: 100%;\n    z-index: 999999;\n}\n", "",{"version":3,"sources":["webpack://./public_feedback/views/styles.module.css"],"names":[],"mappings":"AAAA;IACI,MAAM;IACN,eAAe;IACf,WAAW;IACX,eAAe;AACnB","sourcesContent":[".publicFeedbackOuter {\n    top: 0;\n    position: fixed;\n    width: 100%;\n    z-index: 999999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"publicFeedbackOuter": "styles-module__Vof5f"
};
export default ___CSS_LOADER_EXPORT___;
